module.exports = __webpack_public_path__ + "img/peradi-v1.be207fa2.png";